export const getIsNewQuickDepositButton = (store) =>
  store?.header?.features?.newQuickDepositButton || false;
